document.addEventListener("DOMContentLoaded", function () {
  const allProductOptionBtns = document.querySelectorAll(
    ".product__option-btn"
  );
  for (let i = 0; i < allProductOptionBtns.length; i++) {
    allProductOptionBtns[i].addEventListener("click", function () {
      selectVariant(this);
    });
  }

  function normalizeVariantKey(str) {
    return String(str || "")
      .replace(/\s/g, "")
      .replaceAll("/", "");
  }

  function updateUniqueBundleCells(variantId) {
    document.querySelectorAll("[data-bundle-variant-id]").forEach((cell) => {
      const matches = cell.dataset.bundleVariantId === String(variantId);
      cell.style.display = matches ? "block" : "none";
    });
  }

  function selectVariant(optionSelector) {
    const optionsContainer = optionSelector.closest(".product__options-container");
    const productForm = optionSelector.closest(".product-form");
    const optionsRow = optionSelector.closest(".product__options-row");
    const optionPosition = optionsRow.dataset.position;
    const optionCount = optionsContainer.dataset.optioncount;
    const dataurl = optionsContainer.dataset.url;
    const hiddenOptions = productForm.querySelectorAll("#productFormSelector option");
    const availableOptionsTwo = (optionsContainer.dataset.availableoptionstwo || "").split(", ");
    const availableOptionsThree = (optionsContainer.dataset.availableoptionsthree || "").split(", ");
    const submitBtn = productForm.querySelector(".js-product-form__submit");

    changeSelectedOption(optionSelector);

    if (optionPosition == 1) {
      optionOneClicked(optionSelector, availableOptionsTwo, availableOptionsThree);
    } else if (optionPosition == 2) {
      optionTwoClicked(optionSelector, availableOptionsThree);
    } else {
      optionThreeClicked(optionSelector, availableOptionsThree);
    }

    const optionRowForMatch = Number(optionCount);
    const selectedEl = productForm.querySelector(`#option-${optionRowForMatch} .selected`);
    const selectedVariantRaw =
      optionRowForMatch === 1 ? selectedEl?.dataset?.value : selectedEl?.dataset?.selected;
    const selectedVariantNorm = normalizeVariantKey(selectedVariantRaw);

    let matchedOption = null;
    for (let i = 0; i < hiddenOptions.length; i++) {
      hiddenOptions[i].removeAttribute("selected");
      if (normalizeVariantKey(hiddenOptions[i].innerHTML) === selectedVariantNorm) {
        matchedOption = hiddenOptions[i];
      }
    }

    if (matchedOption) {
      matchedOption.setAttribute("selected", "true");
      const isUpsell = submitBtn.classList.contains("product-form__submit--upsell");
      const variantUrl = dataurl + "?variant=" + matchedOption.value;
      const stockStatus = matchedOption.dataset.stocklevel;

      updateUniqueBundleCells(matchedOption.value);

      if (stockStatus == "Pre-Order") {
        submitBtn.innerText = "Pre-Order";
      } else if (stockStatus == "Sold Out") {
        submitBtn.classList.add("disabled");
        submitBtn.innerText = "Sold Out";
      } else {
        submitBtn.classList.remove("disabled");
        submitBtn.innerText = "Add To Cart";
      }

      if (!isUpsell && window.location.href !== variantUrl) {
        window.history.replaceState({}, "", variantUrl);
      }
    }

    const optionRows = productForm.querySelectorAll(".product__options-row");
    const currentRowNumber = optionsRow.dataset.position;
    for (let i = 0; i < optionRows.length; i++) {
      if (optionRows[i].dataset.position > currentRowNumber) {
        const firstEnabled = optionRows[i].querySelector(".product__option-btn:not(.disabled)");
        if (firstEnabled) firstEnabled.click();
      }
    }

    const optionOuter = optionSelector.closest(".product__option-outer");
    if (optionOuter) {
      optionOuter.classList.toggle("hidden", optionSelector.innerText === "N/A");
    }

    const rightOuter = document.querySelector(".product__right-outer");
    const productOuter = document.querySelector(".product__outer");
    const selectedOptionEl = rightOuter?.querySelector(
      '#productFormSelector > option[selected*="true"]'
    );
    if (selectedOptionEl) {
      const stockIcon = document.querySelector(".product-form__sock-noti-icon");
      const stockText = document.querySelector(".product-form__stock-noti-text");
      const isDisabled = selectedOptionEl.hasAttribute("disabled");
      if (stockIcon) stockIcon.classList.toggle("is-available", !isDisabled);
      if (stockText) stockText.innerHTML = isDisabled ? "SOLD OUT" : "IN STOCK";

      const qtyInput = rightOuter.querySelector(".quantity__input");
      const exVatPrices = document.querySelectorAll(".js-product-price__exvat-price");
      const originalPrices = document.querySelectorAll(".js-product-price__original-price");
      const salePrices = document.querySelectorAll(".js-product-price__sale-price");

      const discountTags = document.querySelectorAll(".js-product-tag__discount");
      discountTags.forEach(discountTag => {
        const discountTagText = discountTag?.querySelector(".product-tag__text-amount");
        const saveAmount = selectedOptionEl.dataset.saveamount;

        if (saveAmount) {
          discountTag.classList.remove("hidden");
          if (discountTagText) discountTagText.innerHTML = saveAmount;
        } else {
          discountTag.classList.add("hidden");
        }
      });
     
      const stockLevelTags = document.querySelectorAll(".js-product-tag__stock-level");
      stockLevelTags.forEach(stockLevelTag => {
        const stockLevelTagText = stockLevelTag?.querySelector(".product-tag__text");
        const stockLevel = selectedOptionEl.dataset.stocklevel;

        if (stockLevelTagText) stockLevelTagText.innerHTML = stockLevel;

        stockLevelTag.classList.remove(
          "product-tag--danger",
          "product-tag--warning",
          "product-tag--success"
        );

        switch (stockLevel) {
          case "Sold Out":
            stockLevelTag.classList.add("product-tag--danger");
            break;
          case "Low Stock":
            stockLevelTag.classList.add("product-tag--warning");
            break;
          case "Pre-Order":
          case "In Stock":
            stockLevelTag.classList.add("product-tag--success");
            break;
        }
      });
      
      if (qtyInput) qtyInput.value = 1;
      exVatPrices.forEach((el) => {
        el.innerHTML = selectedOptionEl.dataset.vatprice ?? "";
      });
      originalPrices.forEach((el) => {
        el.innerHTML = selectedOptionEl.dataset.price ?? "";
      });
      salePrices.forEach((el) => {
        el.innerHTML = selectedOptionEl.dataset.saleprice ?? "";
      });
    }
  }

  const changeSelectedOption = (optionSelector) => {
    const optionRow = optionSelector.closest(".product__options-row"),
      rowOptions = optionRow.querySelectorAll(".product__option-btn");

    for (let i = 0; i < rowOptions.length; i++) {
      rowOptions[i].classList.remove("selected");
    }
    optionSelector.classList.add("selected");
  };

  const optionOneClicked = (
    optionSelector,
    availableOptionsTwo,
    availableOptionsThree
  ) => {
    const productForm = optionSelector.closest(".product-form"),
      optionTwoList = productForm.querySelectorAll(
        "#option-2 .product__option-btn"
      ),
      optionThreeList = productForm.querySelectorAll(
        "#option-3 .product__option-btn"
      );

    for (let i = 0; i < optionTwoList.length; i++) {
      optionTwoList[i].dataset.selected =
        optionSelector.dataset.value + optionTwoList[i].dataset.value;
      if (availableOptionsTwo.includes(optionTwoList[i].dataset.selected)) {
        optionTwoList[i].classList.remove("disabled");
      } else {
        optionTwoList[i].classList.add("disabled");
      }
    }
    for (let i = 0; i < optionThreeList.length; i++) {
      const optionTwo = productForm.querySelector("#option-2 .selected").dataset
        .selected;
      optionThreeList[i].dataset.selected =
        optionTwo + optionThreeList[i].dataset.value;
      if (availableOptionsThree.includes(optionThreeList[i].dataset.selected)) {
        optionThreeList[i].classList.remove("disabled");
      } else {
        optionThreeList[i].classList.add("disabled");
      }
    }
  };

  const optionTwoClicked = (optionSelector, availableOptionsThree) => {
    const productForm = optionSelector.closest(".product-form"),
      optionThreeList = productForm.querySelectorAll(
        "#option-3 .product__option-btn"
      );

    for (let i = 0; i < optionThreeList.length; i++) {
      optionThreeList[i].dataset.selected =
        optionSelector.dataset.selected + optionThreeList[i].dataset.value;
      if (availableOptionsThree.includes(optionThreeList[i].dataset.selected)) {
        optionThreeList[i].classList.remove("disabled");
      } else {
        optionThreeList[i].classList.add("disabled");
      }
    }
  };

  const optionThreeClicked = (optionSelector, availableOptionsThree) => {
    const productForm = optionSelector.closest(".product-form"),
      optionThreeList = productForm.querySelectorAll(
        "#option-3 .product__option-btn"
      ),
      optionTwo = productForm.querySelector("#option-2 .selected").dataset
        .selected;
    for (let i = 0; i < optionThreeList.length; i++) {
      optionThreeList[i].dataset.selected =
        optionTwo + optionThreeList[i].dataset.value;
      if (availableOptionsThree.includes(optionThreeList[i].dataset.selected)) {
        optionThreeList[i].classList.remove("disabled");
      } else {
        optionThreeList[i].classList.add("disabled");
      }
    }
  };

  const firstSelectedFakeOption = document.querySelector(
    ".product__option-btn.selected"
  );
  firstSelectedFakeOption.click();
});
